













































































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { MembershipCategory } from '@subscriptions/interfaces/subscription-category';
import moment from 'moment';

@Component({
  name: 'bpc-membership-category-card',
  components: {},
})
export default class MembershipCategoryCard extends Vue {
  // PROPS
  @Prop(Object) readonly item: MembershipCategory;

  // DATA
  cardType: string = 'membership-category';
  f1: { gradient: ['#3f6ad8'] };

  // LIFECYCLE
  // created () { }
  // mounted () { }
  // updated () { }
  // destroyed () { }

  // COMPUTED
  get period(): string {
    let period = '';
    const start = this.item.fixed_start_date
      ? moment(this.item.fixed_start_date).format('DD/MM/YYYY')
      : '';
    const end = this.item.fixed_end_date
      ? moment(this.item.fixed_end_date).format('DD/MM/YYYY')
      : '';
    if (start && end) {
      period = `${start} - ${end}`;
    } else if (start) {
      period = `From ${end}`;
    } else if (end) {
      period = `Until ${end}`;
    }
    return period;
  }

  get periodColor(): string {
    return this.item.status === 'inactive' ? 'text-danger' : '';
  }

  get totalPaymentsPaid(): number {
    return this.item.total_payments_paid;
  }

  get totalOrdersPrice(): number {
    return this.item.total_orders_price;
  }

  get paidPercentage(): number {
    if (this.totalOrdersPrice) {
      return Math.round((100 * this.totalPaymentsPaid) / this.totalOrdersPrice);
    }
    return 100;
  }

  // METHODS
  onActionClicked(action, row) {
    this.$emit('action-clicked', action, row);
  }
}
